var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm._m(0), _c('p', {
    staticClass: "top-textbox"
  }, [_vm._v(" 本服務提供至 Huggies 好奇台灣官方網站留存資料之會員申請使用。 ")]), _vm._m(1), _c('div', {
    staticClass: "checkbox"
  }, [_c('label', {
    staticClass: "check-wrap",
    attrs: {
      "for": "privacycheck"
    }
  }, [_vm._v("我已閱讀並同意 "), _c('a', {
    attrs: {
      "href": "https://www.huggies.com.tw/zh-tw/privacy-policy",
      "target": "_blank"
    }
  }, [_vm._v("Kimberly-Clark 金百利克拉克公司所有隱私權保護政策及法律聲明 ")]), _vm._v("，並接受相關條款與使用規範。 "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.privacyCheck,
      expression: "privacyCheck"
    }],
    attrs: {
      "name": "privacy",
      "id": "privacycheck",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.privacyCheck) ? _vm._i(_vm.privacyCheck, null) > -1 : _vm.privacyCheck
    },
    on: {
      "change": function change($event) {
        var $$a = _vm.privacyCheck,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.privacyCheck = $$a.concat([$$v]));
          } else {
            $$i > -1 && (_vm.privacyCheck = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.privacyCheck = $$c;
        }
      }
    }
  }), _c('span', {
    staticClass: "checkmark"
  })])]), _c('div', {
    staticClass: "btnwrap fixedbottom",
    attrs: {
      "id": "nextbtn"
    },
    on: {
      "click": _vm.handleNext
    }
  }, [_c('img', {
    attrs: {
      "src": require("./images/btn_next.png"),
      "alt": "下一步"
    }
  })])]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('h1', [_c('span', {
    staticClass: "title"
  }, [_vm._v("申請 LINE 個人化服務")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "scrollbarbox"
  }, [_c('h2', [_vm._v("貼心提醒")]), _c('p', {
    staticClass: "sub"
  }, [_vm._v(" 申請 LINE 官方帳號綁定服務時，Huggies 好奇將根據您提供的行動電話與 LINE 帳號進行身份驗證，本查詢及驗證服務於 Huggies 好奇執行，不會經由 LINE 紀錄資料。"), _c('br'), _c('br'), _vm._v("成功綁定個人化服務後，若更換手機或重新安裝 LINE APP，需以原本 LINE ID 登入，以利後續 LINE 個人化服務使用。"), _c('br')])]);
}]

export { render, staticRenderFns }